import { render, staticRenderFns } from "./day-configurator-add-remark-modal.vue?vue&type=template&id=79ec5d78&scoped=true&"
import script from "./day-configurator-add-remark-modal.vue?vue&type=script&lang=js&"
export * from "./day-configurator-add-remark-modal.vue?vue&type=script&lang=js&"
import style0 from "./day-configurator-add-remark-modal.vue?vue&type=style&index=0&id=79ec5d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec5d78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ec5d78')) {
      api.createRecord('79ec5d78', component.options)
    } else {
      api.reload('79ec5d78', component.options)
    }
    module.hot.accept("./day-configurator-add-remark-modal.vue?vue&type=template&id=79ec5d78&scoped=true&", function () {
      api.rerender('79ec5d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/day-configurator/modals/day-configurator-add-remark-modal.vue"
export default component.exports